module.exports = __webpack_public_path__ + "media/images/bb-login-small-c945c1a68c269b11467b12e52dd71f6c.png";